
import { DocumentTemplate } from '../types';

export const getDefaultTemplates = (funeralHomeId: string): DocumentTemplate[] => [
  {
    id: `tpl-contrato-${Date.now()}`,
    name: 'Contrato de Prestación de Servicios Funerarios',
    funeralHomeId,
    category: 'General',
    content: JSON.stringify([
      { id: 'b1', type: 'heading', content: { level: 1, text: 'CONTRATO DE SERVICIOS FUNERARIOS' }, width: 4 },
      { id: 'b2', type: 'spacer', content: { height: 20 }, width: 4 },
      { id: 'b3', type: 'paragraph', content: 'En Madrid, a {{currentDate}}, reunidos de una parte {{funeralHome.name}}, con CIF {{funeralHome.taxId}} y domicilio en {{funeralHome.address}}, en adelante LA EMPRESA.', width: 4 },
      { id: 'b4', type: 'paragraph', content: 'Y de otra parte D./Dña. {{applicant.fullName}}, con DNI {{applicant.dniNumero}} y domicilio en {{applicant.address}}, en adelante EL SOLICITANTE, quien manifiesta actuar en calidad de {{applicant.relation}} del finado.', width: 4 },
      { id: 'b5', type: 'heading', content: { level: 2, text: 'OBJETO DEL CONTRATO' }, width: 4 },
      { id: 'b6', type: 'paragraph', content: 'LA EMPRESA se compromete a la prestación del servicio funerario de D./Dña. {{deceased.fullName}}, fallecido/a en {{deceased.deathLocation}} el día {{deceased.deathDate}}.', width: 4 },
      { id: 'b7', type: 'paragraph', content: 'El servicio contratado consiste en: {{serviceDetails.plan}}, que incluye los servicios detallados en el presupuesto anexo.', width: 4 },
      { id: 'b8', type: 'divider', content: null, width: 4 },
      { id: 'b9', type: 'paragraph', content: 'El importe total del servicio asciende a la cantidad de {{totalCost}} (IVA incluido).', width: 4 },
      { id: 'b10', type: 'spacer', content: { height: 40 }, width: 4 },
      { id: 'b11', type: 'signature', content: { label: 'Por LA EMPRESA' }, width: 2 },
      { id: 'b12', type: 'signature', content: { label: 'EL SOLICITANTE' }, width: 2 }
    ])
  },
  {
    id: `tpl-cremacion-${Date.now()}`,
    name: 'Autorización de Cremación / Incineración',
    funeralHomeId,
    category: 'General',
    content: JSON.stringify([
      { id: 'c1', type: 'heading', content: { level: 1, text: 'AUTORIZACIÓN DE CREMACIÓN' }, width: 4 },
      { id: 'c2', type: 'spacer', content: { height: 30 }, width: 4 },
      { id: 'c3', type: 'paragraph', content: 'Yo, D./Dña. {{applicant.fullName}}, provisto/a de DNI {{applicant.dniNumero}}, como familiar o persona autorizada de D./Dña. {{deceased.fullName}}.', width: 4 },
      { id: 'c4', type: 'paragraph', content: 'SOLICITO Y AUTORIZO a que se proceda a la incineración del cadáver de la persona mencionada anteriormente, manifestando bajo mi responsabilidad que el fallecido/a no portaba marcapasos ni otros dispositivos que pudieran causar riesgo en el proceso.', width: 4 },
      { id: 'c5', type: 'paragraph', content: 'Lugar de destino de las cenizas: {{serviceDetails.location}}.', width: 4 },
      { id: 'c6', type: 'spacer', content: { height: 50 }, width: 4 },
      { id: 'c7', type: 'signature', content: { label: 'Firma del Solicitante' }, width: 4 }
    ])
  },
  {
    id: `tpl-rgpd-${Date.now()}`,
    name: 'Consentimiento para Tratamiento de Datos (RGPD)',
    funeralHomeId,
    category: 'General',
    content: JSON.stringify([
      { id: 'r1', type: 'heading', content: { level: 2, text: 'PROTECCIÓN DE DATOS DE CARÁCTER PERSONAL' }, width: 4 },
      { id: 'r2', type: 'paragraph', content: 'En cumplimiento del Reglamento (UE) 2016/679 (RGPD), le informamos que sus datos personales serán tratados por {{funeralHome.name}} con la finalidad de gestionar la prestación del servicio funerario y la facturación del mismo.', width: 4 },
      { id: 'r3', type: 'paragraph', content: 'Los datos se conservarán durante el tiempo necesario para cumplir con las obligaciones legales. Usted tiene derecho a acceder, rectificar y suprimir sus datos, así como otros derechos explicados en nuestra política de privacidad.', width: 4 },
      { id: 'r4', type: 'paragraph', content: '☐ Consiento el tratamiento de mis datos para las finalidades descritas.', width: 4 },
      { id: 'r5', type: 'spacer', content: { height: 30 }, width: 4 },
      { id: 'r6', type: 'signature', content: { label: 'Firma de Conformidad' }, width: 4 }
    ])
  },
  {
    id: `tpl-tanatopraxia-${Date.now()}`,
    name: 'Autorización de Prácticas de Tanatopraxia',
    funeralHomeId,
    category: 'General',
    content: JSON.stringify([
      { id: 't1', type: 'heading', content: { level: 1, text: 'AUTORIZACIÓN DE PRÁCTICAS SANITARIAS' }, width: 4 },
      { id: 't2', type: 'spacer', content: { height: 20 }, width: 4 },
      { id: 't3', type: 'paragraph', content: 'D./Dña. {{applicant.fullName}}, mayor de edad, con DNI {{applicant.dniNumero}}.', width: 4 },
      { id: 't4', type: 'paragraph', content: 'AUTORIZA expresamente a {{funeralHome.name}} a realizar las prácticas de tanatopraxia o tanatoestética necesarias sobre el cuerpo de D./Dña. {{deceased.fullName}}, para asegurar su correcta conservación y presentación con fines de velatorio y despedida.', width: 4 },
      { id: 't5', type: 'spacer', content: { height: 40 }, width: 4 },
      { id: 't6', type: 'signature', content: { label: 'Firma Autorización' }, width: 4 }
    ])
  },
  {
    id: `tpl-certificados-${Date.now()}`,
    name: 'Solicitud de Certificados y Últimas Voluntades',
    funeralHomeId,
    category: 'General',
    content: JSON.stringify([
      { id: 'ac1', type: 'heading', content: { level: 1, text: 'SOLICITUD DE GESTIÓN DE CERTIFICADOS' }, width: 4 },
      { id: 'ac2', type: 'paragraph', content: 'D./Dña. {{applicant.fullName}}, con DNI {{applicant.dniNumero}}, autoriza a {{funeralHome.name}} a solicitar en su nombre los siguientes documentos:', width: 4 },
      { id: 'ac3', type: 'paragraph', content: '• Certificado literal de defunción en el Registro Civil correspondiente.', width: 4 },
      { id: 'ac4', type: 'paragraph', content: '• Certificado de Actos de Última Voluntad.', width: 4 },
      { id: 'ac5', type: 'paragraph', content: '• Certificado de Contratos de Seguros de cobertura de fallecimiento.', width: 4 },
      { id: 'ac6', type: 'spacer', content: { height: 40 }, width: 4 },
      { id: 'ac7', type: 'signature', content: { label: 'Firma del Solicitante' }, width: 4 }
    ])
  },
  {
    id: `tpl-presupuesto-${Date.now()}`,
    name: 'Presupuesto Detallado de Servicios',
    funeralHomeId,
    category: 'General',
    content: JSON.stringify([
      { id: 'p1', type: 'heading', content: { level: 1, text: 'PRESUPUESTO DETALLADO' }, width: 4 },
      { id: 'p2', type: 'paragraph', content: 'Nº Presupuesto: {{caseId}} | Fecha: {{currentDate}}', width: 4 },
      { id: 'p3', type: 'spacer', content: { height: 20 }, width: 4 },
      { id: 'p4', type: 'paragraph', content: 'SOLICITANTE: {{applicant.fullName}}', width: 2 },
      { id: 'p5', type: 'paragraph', content: 'DIFUNTO: {{deceased.fullName}}', width: 2 },
      { id: 'p6', type: 'divider', content: null, width: 4 },
      { id: 'p7', type: 'heading', content: { level: 2, text: 'DESGLOSE DE SERVICIOS' }, width: 4 },
      { id: 'p8', type: 'paragraph', content: 'Servicio Principal ({{serviceDetails.plan}}): {{serviceDetails.planPrice}}', width: 4 },
      { id: 'p9', type: 'paragraph', content: 'Servicios Adicionales y Arrendamientos: Incluidos según catálogo vigente.', width: 4 },
      { id: 'p10', type: 'spacer', content: { height: 20 }, width: 4 },
      { id: 'p11', type: 'heading', content: { level: 1, text: 'TOTAL PRESUPUESTO: {{totalCost}}' }, width: 4 },
      { id: 'p12', type: 'paragraph', content: 'Nota: Previsión de gastos sujeta a variaciones oficiales por tasas de cementerio o registros.', width: 4 },
      { id: 'p13', type: 'signature', content: { label: 'Aceptación del Cliente' }, width: 4 }
    ])
  },
  {
    id: `tpl-cenizas-${Date.now()}`,
    name: 'Autorización de Destino de Cenizas',
    funeralHomeId,
    category: 'General',
    content: JSON.stringify([
      { id: 'az1', type: 'heading', content: { level: 1, text: 'AUTORIZACIÓN DE DESTINO DE CENIZAS' }, width: 4 },
      { id: 'az2', type: 'paragraph', content: 'Por la presente, D./Dña. {{applicant.fullName}}, con DNI {{applicant.dniNumero}}, autoriza a {{funeralHome.name}} a realizar la entrega de las cenizas de D./Dña. {{deceased.fullName}}.', width: 4 },
      { id: 'az3', type: 'paragraph', content: 'Destino final declarado:', width: 4 },
      { id: 'az4', type: 'paragraph', content: '[ ] Entrega a la familia para custodia en domicilio.', width: 4 },
      { id: 'az5', type: 'paragraph', content: '[ ] Depósito en Columbarios: {{serviceDetails.location}}.', width: 4 },
      { id: 'az6', type: 'paragraph', content: '[ ] Esparcimiento en Jardín del Recuerdo.', width: 4 },
      { id: 'az7', type: 'paragraph', content: 'El solicitante exime a la funeraria de cualquier responsabilidad una vez realizada la entrega bajo protocolo.', width: 4 },
      { id: 'az8', type: 'signature', content: { label: 'Firma del Receptor/Solicitante' }, width: 4 }
    ])
  },
  {
    id: `tpl-madrid-acta-${Date.now()}`,
    name: '[Madrid] Acta de Conservación / Embalsamamiento',
    funeralHomeId,
    category: 'Madrid',
    content: JSON.stringify([
      { id: 'ma1', type: 'heading', content: { level: 2, text: 'ACTA DE PRÁCTICA TANATOPLÁSTICA (Dto. 124/1997)' }, width: 4 },
      { id: 'ma2', type: 'paragraph', content: 'En cumplimiento de la normativa de Sanidad Mortuoria de la Comunidad de Madrid.', width: 4 },
      { id: 'ma3', type: 'paragraph', content: 'DIFUNTO: {{deceased.fullName}} | CAUSA: Natural', width: 4 },
      { id: 'ma4', type: 'paragraph', content: 'Se procede a la práctica de: [ ] CONSERVACIÓN TEMPORAL [ ] EMBALSAMAMIENTO', width: 4 },
      { id: 'ma5', type: 'paragraph', content: 'Realizado por el facultativo/tanatopractor autorizado en las instalaciones de {{funeralHome.name}}.', width: 4 },
      { id: 'ma6', type: 'signature', content: { label: 'Firma Tanatopractor' }, width: 2 },
      { id: 'ma7', type: 'signature', content: { label: 'Vº Bº Director Centro' }, width: 2 }
    ])
  },
  {
    id: `tpl-andalucia-cert-${Date.now()}`,
    name: '[Andalucía] Certificado para Inhumación / Incineración',
    funeralHomeId,
    category: 'Andalucía',
    content: JSON.stringify([
      { id: 'an1', type: 'heading', content: { level: 1, text: 'CERTIFICADO DE REQUISITOS (Dto. 95/2001)' }, width: 4 },
      { id: 'an2', type: 'paragraph', content: 'La empresa funeraria {{funeralHome.name}} certifica que el cadáver de D./Dña. {{deceased.fullName}} cumple con todos los requisitos técnicos para su destino final en Andalucía.', width: 4 },
      { id: 'an3', type: 'paragraph', content: 'Tipo de servicio: {{serviceDetails.type}}', width: 4 },
      { id: 'an4', type: 'paragraph', content: 'Fecha oficial de salida: {{currentDate}}', width: 4 },
      { id: 'an5', type: 'spacer', content: { height: 30 }, width: 4 },
      { id: 'an6', type: 'signature', content: { label: 'Firma y Sello Funeraria' }, width: 4 }
    ])
  },
  {
    id: `tpl-bal-traslado-${Date.now()}`,
    name: '[Baleares] Declaración Responsable de Traslado (Anexo 4)',
    funeralHomeId,
    category: 'Baleares',
    content: JSON.stringify([
      { id: 'ba1', type: 'heading', content: { level: 1, text: 'DECLARACIÓN RESPONSABLE DE TRASLADO' }, width: 4 },
      { id: 'ba2', type: 'paragraph', content: 'CUMPLIMIENTO DE CONDICIONES SANITARIAS (ANEXO 4 - DTO 11/2018)', width: 4 },
      { id: 'ba3', type: 'paragraph', content: 'D./Dña. {{applicant.fullName}}, representante de {{funeralHome.name}}, bajo su responsabilidad DECLARA:', width: 4 },
      { id: 'ba4', type: 'paragraph', content: 'Que el cadáver de D./Dña. {{deceased.fullName}}, fallecido/a en {{deceased.deathLocation}}, ha sido preparado según las normas técnicas vigentes para su traslado fuera de la isla de origen.', width: 4 },
      { id: 'ba5', type: 'paragraph', content: 'Destino final del traslado: {{serviceDetails.location}}', width: 4 },
      { id: 'ba6', type: 'spacer', content: { height: 20 }, width: 4 },
      { id: 'ba7', type: 'paragraph', content: 'Esta declaración se presenta ante la Dirección General de Salud Pública con fecha {{currentDate}}.', width: 4 },
      { id: 'ba8', type: 'signature', content: { label: 'Firma del Declarante' }, width: 4 }
    ])
  },
  {
    id: `tpl-bal-inc-urgente-${Date.now()}`,
    name: '[Baleares] Solicitud de Incineración Urgente (Anexo 3)',
    funeralHomeId,
    category: 'Baleares',
    content: JSON.stringify([
      { id: 'bu1', type: 'heading', content: { level: 2, text: 'SOLICITUD DE INCINERACIÓN ANTES DE 24 HORAS' }, width: 4 },
      { id: 'bu2', type: 'paragraph', content: '(ANEXO 3 - DECRETO 11/2018)', width: 4 },
      { id: 'bu3', type: 'paragraph', content: 'Se solicita autorización para la incineración urgente de D./Dña. {{deceased.fullName}}, por motivos [ ] Religiosos [ ] Sanitarios [ ] Logísticos justificados.', width: 4 },
      { id: 'bu4', type: 'paragraph', content: 'La funeraria certifica que se han realizado las comunicaciones pertinentes al Registro Civil.', width: 4 },
      { id: 'bu5', type: 'signature', content: { label: 'Firma Solicitante' }, width: 2 },
      { id: 'bu6', type: 'signature', content: { label: 'Vº Bº Médico' }, width: 2 }
    ])
  },
  {
    id: `tpl-can-incineracion-${Date.now()}`,
    name: '[Canarias] Licencia de Incineración',
    funeralHomeId,
    category: 'Canarias',
    content: JSON.stringify([
      { id: 'ci1', type: 'heading', content: { level: 1, text: 'LICENCIA DE INCINERACIÓN (CANARIAS)' }, width: 4 },
      { id: 'ci2', type: 'paragraph', content: 'Documento habilitante para el acceso a las instalaciones del crematorio insular.', width: 4 },
      { id: 'ci3', type: 'paragraph', content: 'DIFUNTO: {{deceased.fullName}} | DNI: {{deceased.dniNumero}}', width: 4 },
      { id: 'ci4', type: 'paragraph', content: 'SOLICITANTE: {{applicant.fullName}}', width: 4 },
      { id: 'ci5', type: 'divider', content: null, width: 4 },
      { id: 'ci6', type: 'paragraph', content: 'Queda autorizado el proceso de incineración del cadáver referenciado en este documento bajo la normativa del Decreto 132/2014.', width: 4 },
      { id: 'ci7', type: 'signature', content: { label: 'Sello y Firma Autorizada' }, width: 4 }
    ])
  },
  {
    id: `tpl-can-traslado-${Date.now()}`,
    name: '[Canarias] Declaración de Traslado Interinsular / Aéreo',
    funeralHomeId,
    category: 'Canarias',
    content: JSON.stringify([
      { id: 'ct1', type: 'heading', content: { level: 1, text: 'CERTIFICADO TÉCNICO DE TRASLADO (CANARIAS)' }, width: 4 },
      { id: 'ct2', type: 'paragraph', content: 'Válido para transporte aéreo o marítimo interisland según Dto. 132/2014.', width: 4 },
      { id: 'ct3', type: 'paragraph', content: 'La empresa {{funeralHome.name}} certifica que el féretro que contiene a D./Dña. {{deceased.fullName}} cumple con las normas de estanqueidad y presurización requeridas para el transporte en bodega.', width: 4 },
      { id: 'ct4', type: 'paragraph', content: 'Aeropuerto/Puerto de Salida: {{funeralHome.address}}', width: 2 },
      { id: 'ct5', type: 'Aeropuerto/Puerto de Destino: {{serviceDetails.location}}', width: 2 },
      { id: 'ct6', type: 'signature', content: { label: 'Director Técnico' }, width: 4 }
    ])
  }
];
